import { useEffect, useState } from "react";

// `ids` must be referentially stable (e.g. a module-level constant)
export function useActiveSection(ids: readonly string[], fallback = "home") {
  const [active, setActive] = useState(fallback);

  useEffect(() => {
    const visible = new Set<string>();
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            visible.add(entry.target.id);
          } else {
            visible.delete(entry.target.id);
          }
        }
        setActive(ids.find((id) => visible.has(id)) ?? fallback);
      },
      // A section is active while it crosses the vertical middle of the
      // viewport, regardless of how tall it is
      { rootMargin: "-50% 0px -50% 0px" },
    );

    for (const id of ids) {
      const element = document.getElementById(id);
      if (element) {
        observer.observe(element);
      }
    }

    return () => {
      observer.disconnect();
    };
  }, [ids, fallback]);

  return active;
}
